<kendo-expansionpanel [title]="title"
                      [subtitle]="'Total: ' + customerActionList.length"
                      [expanded]="expanded">
    <div class="row">
        <div [ngClass]="isEdit || isAdd ? 'col-sm-6' : 'col-sm-11'">
            <kendo-grid #customerActionGrid
                        [data]="gridData"
                        [pageSize]="gridState.take"
                        [skip]="gridState.skip"
                        [sort]="gridState.sort"
                        [filter]="gridState.filter"
                        [pageable]="true"
                        [sortable]="true"
                        [filterable]="true"
                        [resizable]="true"
                        [autoSize]="true"
                        (dataStateChange)="dataStateChange($event)">
                <kendo-grid-column title="Action">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem.customerActionID)"><i class="fas fa-pencil-alt"></i></button>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="eventDate" title="Event Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.eventDate | date: 'M/dd/yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="actionTypeDescription" title="Type"></kendo-grid-column>
                <kendo-grid-column field="contactName" title="Contact"></kendo-grid-column>
                <kendo-grid-column field="createdByEmployeeName" title="Created"></kendo-grid-column>
                <kendo-grid-column field="notes" title="Notes">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{getActionNotes(dataItem)}}
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
        <div class="col-sm-1" *ngIf="!isEdit && !isAdd">
            <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
        </div>

        <div class="col-sm-6" *ngIf="isEdit || isAdd">
            <!-- Edit Customer Action form -->
            <customer-action-form [customerActionID]="customerActionID" [opportunityID]="opportunityID" [customerID]="customerID" (onRefresh)="cancelEdit()"></customer-action-form>
        </div>
    </div>
</kendo-expansionpanel>
